import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPageEmpty"><Path d="M20 2H4V22H20V2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageEmpty;
